/* Coalesce repeated app DOM updates into one scan per animation frame. */
function usaBatchDomScan(callback){let frame=0;return ()=>{if(!frame)frame=requestAnimationFrame(()=>{frame=0;callback();});};}
/* Ignore mobile address-bar height changes for width-dependent layout work. */
function usaWidthLayoutResize(callback){let width=document.documentElement.clientWidth;return function(event){const next=document.documentElement.clientWidth;if(next===width&&window.matchMedia('(max-width:1199px)').matches)return;width=next;callback(event);};}
/* Draft-only motion: native scrolling, one-shot reveals, no per-frame layout work. */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  function start() {
    const main = document.getElementById('MainContent');
    if (!main || !('IntersectionObserver' in window)) return;
    const departments=main.querySelector('.usa-home .usa-depts');
    if(departments&&departments.children.length===5&&!departments.querySelector('a[href="/collections/health-care"]')){
      const department=document.createElement('a');
      department.className='usa-dept';department.href='/collections/health-care';
      department.innerHTML='<img class="usa-dept-photo" src="https://cdn.shopify.com/s/files/1/0552/9704/8748/collections/61G3FDAnC8L._SL1500.jpg?v=1770741642&width=480" alt="" width="480" height="480" loading="lazy" style="object-fit:contain;background:#fff"><span class="usa-dept-content"><strong>Health &amp; OTC</strong><span>Everyday health essentials</span></span>';
      departments.append(department);
      const lifestyle=main.querySelector('[data-health-image]')?.dataset.healthImage;
      if(lifestyle){const photo=department.querySelector('img');photo.sizes='(max-width: 1199px) 60vw, 16vw';photo.srcset=main.querySelector('[data-health-srcset]')?.dataset.healthSrcset||'';photo.src=lifestyle;photo.width=640;photo.height=640;photo.style.objectFit='cover';}
    }
    if(location.pathname==='/'||location.pathname.startsWith('/products/')) {
      const signup=document.querySelector('.usa-promo.signup')||document.getElementById('usa-footer-offer');
      if(signup&&!document.getElementById('usa-signup-edge-tab')){
        if(!signup.id)signup.id='usa-home-signup-card';
        const tab=document.createElement('button');
        tab.type='button';tab.id='usa-signup-edge-tab';
        tab.textContent='10% OFF £20+ · SIGN UP';tab.setAttribute('aria-label','Get 10% off your first order of £20 or more');
        tab.setAttribute('aria-haspopup','dialog');tab.setAttribute('aria-controls','usa-signup-drawer');
        tab.hidden=true;document.body.append(tab);
        const visible=new Set();
        const desktopTab=matchMedia('(min-width:1200px)');
        const sync=()=>{
          const cardVisible=signup.matches('.usa-promo.signup')&&visible.has(signup);
          tab.hidden=false;
        };
        desktopTab.addEventListener('change',sync);
        const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>entry.isIntersecting?visible.add(entry.target):visible.delete(entry.target));sync();});
        [signup,document.getElementById('usa-footer-offer')].filter(Boolean).forEach(el=>{
          const rect=el.getBoundingClientRect();if(rect.bottom>0&&rect.top<innerHeight)visible.add(el);
          observer.observe(el);
        });
        sync();
        const hero=document.querySelector('.usa-hero-refresh');
        if(hero){
          let positionFrame=0;
          const positionTab=()=>{
            positionFrame=0;
            const heroBottom=hero.getBoundingClientRect().bottom;
            const mobile=!desktopTab.matches;
            const center=mobile?document.documentElement.clientHeight/2:Math.max(innerHeight/2,heroBottom+16+tab.offsetHeight/2);
            const beforeHero=mobile&&heroBottom+16>center-tab.offsetHeight/2;
            const card=signup.getBoundingClientRect();
            const top=mobile?'50svh':center+'px';
            // Complete geometry reads before style writes; don't restyle a stationary tab.
            if(tab.style.top!==top)tab.style.top=top;
            tab.classList.toggle('is-before-hero',beforeHero);
            tab.classList.toggle('is-magnet',signup.matches('.usa-promo.signup')&&center>=card.top+20&&center<=card.bottom-20);
          };
          const queuePosition=()=>{if(!positionFrame)positionFrame=requestAnimationFrame(positionTab);};
          addEventListener('scroll',queuePosition,{passive:true});addEventListener('resize',queuePosition,{passive:true});new ResizeObserver(queuePosition).observe(hero);positionTab();
        }
        const source=signup.querySelector('form');
        if(!source){tab.remove();return;}
        const drawer=document.createElement('dialog');drawer.id='usa-signup-drawer';drawer.setAttribute('aria-labelledby','usa-signup-drawer-title');drawer.setAttribute('autofocus','');
        drawer.innerHTML='<div class="usa-signup-panel"><button type="button" class="usa-signup-close" aria-label="Close signup">×</button><h2 id="usa-signup-drawer-title">New here? Get 10% off your first order of £20 or more</h2><p>Sign up for US favourites, new arrivals and email offers.</p><div class="usa-signup-form"></div><p class="usa-signup-privacy">By signing up, you agree to receive marketing emails. Unsubscribe anytime. <a href="/policies/privacy-policy">Privacy policy</a></p></div>';
        const form=source.cloneNode(true);
        if(/agree to receive marketing/i.test(form.textContent))drawer.querySelector('.usa-signup-privacy').remove();
        const ids=new Map();[form,...form.querySelectorAll('[id]')].forEach(el=>{if(el.id){ids.set(el.id,'drawer-'+el.id);el.id='drawer-'+el.id;}});
        form.querySelectorAll('[for],[aria-describedby],[aria-labelledby]').forEach(el=>['for','aria-describedby','aria-labelledby'].forEach(attr=>{if(el.hasAttribute(attr))el.setAttribute(attr,el.getAttribute(attr).split(' ').map(id=>ids.get(id)||id).join(' '));}));
        form.querySelectorAll('input[type="email"]').forEach(el=>{el.required=true;el.autocomplete='email';el.setAttribute('aria-label','Email address');});
        drawer.querySelector('.usa-signup-form').append(form);document.body.append(drawer);
        let closing=false,oldOverflow='';
        const sizeSignupViewport=()=>{
          if(!drawer.open)return;
          const viewport=window.visualViewport;
          drawer.style.setProperty('--usa-signup-visible-height',(viewport?.height||window.innerHeight)+'px');
          drawer.style.setProperty('--usa-signup-visible-top',(viewport?.offsetTop||0)+'px');
        };
        window.visualViewport?.addEventListener('resize',sizeSignupViewport,{passive:true});
        window.visualViewport?.addEventListener('scroll',sizeSignupViewport,{passive:true});
        window.addEventListener('resize',sizeSignupViewport,{passive:true});
        const close=()=>{if(closing||!drawer.open)return;closing=true;drawer.classList.remove('is-visible');setTimeout(()=>{drawer.close();document.documentElement.style.overflow=oldOverflow;closing=false;tab.focus({preventScroll:true});},reduce.matches?0:350);};
        tab.addEventListener('click',()=>{
          if(drawer.open||closing)return;
          oldOverflow=document.documentElement.style.overflow;
          drawer.classList.remove('is-visible');drawer.showModal();
          sizeSignupViewport();
          document.documentElement.style.overflow='hidden';
          // Commit the offscreen starting position before transitioning in.
          drawer.querySelector('.usa-signup-panel').getBoundingClientRect();
          requestAnimationFrame(()=>requestAnimationFrame(()=>drawer.classList.add('is-visible')));
          // Never focus an offscreen field: mobile Safari can pan the page to it.
          // On touch screens let customers tap the visible field to open the keyboard.
          if(matchMedia('(hover:hover) and (pointer:fine)').matches)setTimeout(()=>{
            if(drawer.open&&!closing)drawer.querySelector('input[type="email"]')?.focus({preventScroll:true});
          },reduce.matches?0:350);
        });
        drawer.querySelector('.usa-signup-close').addEventListener('click',close);
        drawer.addEventListener('cancel',event=>{event.preventDefault();close();});
        drawer.addEventListener('click',event=>{if(event.target===drawer)close();});
      }
    }
    // One shared frame for visible image groups; no card/grid scaling or hidden text.
    const focusStates = new Map(), activeFocus = new Set();
    let focusFrame = 0, focusListening = false;
    function drawFocus() {
      focusFrame = 0;
      if (reduce.matches || document.hidden) return;
      const updates = [];
      activeFocus.forEach(state => {
        if (!state.root.isConnected) {activeFocus.delete(state);focusStates.delete(state.root);return;}
        const rect = state.root.getBoundingClientRect();
        const travel = state.collection ? innerHeight*.75 : innerHeight+rect.height;
        const progress = Math.max(0,Math.min(1,(innerHeight-rect.top)/travel));
        const scale = (1+progress*state.amount).toFixed(4);
        if (scale !== state.last) {state.last=scale;updates.push([state,scale]);}
      });
      updates.forEach(([state,scale])=>state.images.forEach(image=>image.style.setProperty('--usa-scroll-focus-scale',scale)));
    }
    function queueFocus(){if(!focusFrame)focusFrame=requestAnimationFrame(drawFocus);}
    function syncFocus(){
      const enabled=activeFocus.size>0&&!reduce.matches&&!document.hidden;
      if(enabled&&!focusListening){addEventListener('scroll',queueFocus,{passive:true});addEventListener('resize',queueFocus,{passive:true});focusListening=true;}
      else if(!enabled&&focusListening){removeEventListener('scroll',queueFocus);removeEventListener('resize',queueFocus);focusListening=false;cancelAnimationFrame(focusFrame);focusFrame=0;}
      if(reduce.matches)focusStates.forEach(state=>{state.last=null;state.images.forEach(image=>image.style.removeProperty('--usa-scroll-focus-scale'));});
      if(enabled)queueFocus();
    }
    const focusObserver=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{const state=focusStates.get(entry.target);if(!state)return;if(entry.isIntersecting)activeFocus.add(state);else activeFocus.delete(state);});syncFocus();
    });
    const focusSelector='.usa-home .usa-depts';
    function registerFocus(root){
      if(focusStates.has(root))return;
      const images=root.matches('.usa-depts')?[...root.querySelectorAll('.usa-dept-photo')]:[root.querySelector('.card__media img')].filter(Boolean);
      if(!images.length)return;
      images.forEach(image=>image.classList.add('usa-scroll-focus-target'));
      focusStates.set(root,{root,images,amount:.24,collection:root.matches('#product-grid>.grid__item'),last:null});focusObserver.observe(root);
    }
    main.querySelectorAll(focusSelector).forEach(registerFocus);
    // Departments are static except when a merchant reloads a section in the editor.
    document.addEventListener('shopify:section:load',()=>main.querySelectorAll(focusSelector).forEach(registerFocus));
    reduce.addEventListener('change',syncFocus);document.addEventListener('visibilitychange',syncFocus);
    // Fill the initial viewport, then reveal complete product rows as they enter it.
    if(location.pathname.startsWith('/collections/') || location.pathname.startsWith('/search')) {
      main.classList.add('usa-collection-nozoom');
      const shown=new WeakSet();
      const rowByCard=new WeakMap();
      const cardSelector='#product-grid>.grid__item';
      let scanFrame=0, initialized=false;
      const revealRow=(row,animate=true)=>{
        if(!row)return;
        slides.unobserve(row[0]);
        row.forEach(card=>{
          if(!animate || reduce.matches){
            shown.add(card);card.classList.remove('usa-collection-ready','usa-collection-slide');return;
          }
          if(shown.has(card))return;
          shown.add(card);
          card.classList.add('usa-collection-slide');
          const finish=event=>{
            if(event.target!==card)return;
            card.classList.remove('usa-collection-slide','usa-collection-ready');
            card.removeEventListener('animationend',finish);
          };
          card.addEventListener('animationend',finish);
        });
      };
      const slides=new IntersectionObserver(entries=>entries.forEach(entry=>{
        if(entry.isIntersecting)revealRow(rowByCard.get(entry.target));
      }),{threshold:0,rootMargin:'0px'});
      const scan=(initial=false)=>{
        slides.disconnect();
        // Group using untransformed layout positions; reads precede style writes.
        const grids=[...main.querySelectorAll('#product-grid')].map(grid=>{
          const rows=[];
          [...grid.children].filter(card=>card.matches('.grid__item')).forEach(card=>{
            const top=card.offsetTop;
            // Rounding can put cards in the same visual row a pixel apart.
            let row=rows.find(row=>Math.abs(row.top-top)<=2);
            if(!row){row={top,cards:[]};rows.push(row);}
            row.cards.push(card);
          });
          return rows.map(({cards:row})=>({row,top:row[0].getBoundingClientRect().top}));
        });
        grids.flat().forEach(({row,top})=>{
          row.forEach(card=>rowByCard.set(card,row));
          if(row.every(card=>shown.has(card)))return;
          if(reduce.matches || (initial && top<innerHeight) || row.some(card=>shown.has(card))){
            revealRow(row,false);return;
          }
          row.forEach((card,column)=>{
            // Keep a short left-to-right overlap without long waits between cards.
            card.style.setProperty('--usa-reveal-delay',`${column*250}ms`);
            card.classList.add('usa-collection-ready');
          });
          slides.observe(row[0]);
        });
      };
      const schedule=()=>{
        if(!initialized)return;
        cancelAnimationFrame(scanFrame);scanFrame=requestAnimationFrame(()=>scan());
      };
      // Set the initial boundary once, after final typography and grid styles settle.
      // Never reset shown cards later: that could split a row across two reveals.
      const pageReady=document.readyState!=='loading'?Promise.resolve():new Promise(resolve=>document.addEventListener('DOMContentLoaded',resolve,{once:true}));
      pageReady.then(async()=>{
        const title=main.querySelector('.usa-product-name,.card__heading');
        if(title&&document.fonts){const font=getComputedStyle(title);await Promise.race([document.fonts.load(`${font.fontWeight} ${font.fontSize} ${font.fontFamily}`).catch(()=>{}),new Promise(resolve=>setTimeout(resolve,1000))]);}
        requestAnimationFrame(()=>{initialized=true;scan(true);});
      });
      window.addEventListener('resize',usaWidthLayoutResize(schedule),{passive:true});
      document.addEventListener('usa:collection-restored',()=>scan(true));
      // Keyboard navigation must not land on a hidden product.
      main.addEventListener('focusin',event=>{
        const card=event.target.closest(cardSelector);
        if(card)revealRow(rowByCard.get(card),false);
      });
      reduce.addEventListener('change',()=>{
        if(reduce.matches)main.querySelectorAll(cardSelector).forEach(card=>{
          shown.add(card);card.classList.remove('usa-collection-ready','usa-collection-slide');
        });
        schedule();
      });
      new MutationObserver(records=>{
        if(records.some(record=>[...record.addedNodes].some(node=>
          node.nodeType===1&&(node.matches(cardSelector)||node.querySelector(cardSelector)))))schedule();
      }).observe(main,{childList:true,subtree:true});
    }
    const seen = new WeakSet();
    const reveals = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      reveals.unobserve(entry.target);
      if (!reduce.matches) {
        entry.target.classList.add('usa-section-enter');
        entry.target.addEventListener('animationend', () => entry.target.classList.remove('usa-section-enter'), {once:true});
      }
    }), {threshold:0.05});
    // Product sliders reveal as a group. Never animate the hero, buy box or sticky ancestors.
    main.querySelectorAll('.usa-brands,.usa-discovery-section,.rich-text__blocks,.image-with-text__content,.section-related-products').forEach(el => {
      if (seen.has(el) || el.closest('.usa-hero,.usa-editorial-hero,slideshow-component') || el.getBoundingClientRect().top < innerHeight) return;
      seen.add(el); reveals.observe(el);
    });
    reduce.addEventListener('change', () => {
      if (reduce.matches) main.querySelectorAll('.usa-section-enter').forEach(el => el.classList.remove('usa-section-enter'));
    });
    window.addEventListener('pagehide', () => {reveals.disconnect();}, {once:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();

/* App search cards reuse their existing cart forms in the collection price row. */
(()=>{

 const icon="<svg xmlns=\"http://www.w3.org/2000/svg\"\n     viewBox=\"0 0 512 512\"\n     class=\"icon icon-cart\"\n     aria-hidden=\"true\"\n     focusable=\"false\">\n  <path d=\"M80 176a16 16 0 00-16 16v216c0 30.24 25.76 56 56 56h272c30.24 0 56-24.51 56-54.75V192a16 16 0 00-16-16zM160 176v-32a96 96 0 0196-96h0a96 96 0 0196 96v32\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"32\"/>\n  <path d=\"M160 224v16a96 96 0 0096 96h0a96 96 0 0096-96v-16\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"32\"/>\n</svg>";
 function sync(){
  document.querySelectorAll('.card-wrapper').forEach(card=>{
   const price=card.querySelector('.card-information > .price');
   const quick=card.querySelector('.quick-add');
   const button=quick?.querySelector('button[name="add"]');
   const label=button?.textContent.trim().toLowerCase();
   if(!button||button.disabled||!(label?.includes('cart')||label?.includes('notify'))) return;
   if(label.includes('notify')&&!button.querySelector('.usa-collection-cart-icon')){const bell=document.createElement('span');bell.className='icon-wrap usa-collection-cart-icon usa-notify-icon';bell.innerHTML='<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9Z M10 21h4"/></svg>';button.prepend(bell);button.setAttribute('aria-label','Notify me');button.classList.add('usa-compact-notify');}
   if(!price||card.querySelector('.usa-collection-price-row')) return;
   const wrap=button.querySelector('.icon-wrap');
   if(!wrap) return;
   wrap.classList.add('usa-collection-cart-icon');
   if(!label.includes('notify'))wrap.innerHTML=icon;
   const row=document.createElement('div');
   row.className='usa-collection-price-row';
   price.before(row); row.append(price,quick);
  });
 }
 let scheduled=false;
 function schedule(){if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;sync()})}
 function start(){sync();const main=document.getElementById('MainContent');if(main)new MutationObserver(schedule).observe(main,{childList:true,subtree:true})}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();

/* Keep main product and sticky purchase actions compact without replacing forms. */
(()=>{function sync(){document.querySelectorAll('.sticky-cta button').forEach(button=>{if(button.classList.contains('usa-compact-action'))return;const label=button.textContent.trim();if(!/cart|notify/i.test(label))return;button.classList.add('usa-compact-action');button.classList.toggle('usa-bell-action',/notify/i.test(label));if(!button.getAttribute('aria-label'))button.setAttribute('aria-label',label);button.title=label;});}let frame=0;function schedule(){if(!frame)frame=requestAnimationFrame(()=>{frame=0;sync();});}function start(){sync();new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();})();

/* Align homepage rail/grid titles without truncating product names. */
(()=>{
 const selector='body:is(.collection-template,.search-template,.page-a-search) #product-grid,.usa-products,.usa-discovery-grid,.product-grid';
 let frame=0;
 function align(){
  frame=0;
  const groups=[...document.querySelectorAll(selector)].map(group=>({group,titles:[...group.querySelectorAll('.card__information>.card__heading')]})).filter(item=>item.titles.length);
  // Read title geometry together; the unused name-height pass caused an extra layout.
  const heights=groups.map(({group,titles})=>({group,height:Math.ceil(Math.max(...titles.map(title=>title.getBoundingClientRect().height)))}));
  heights.forEach(({group,height})=>{const value=height+'px';if(height&&group.style.getPropertyValue('--usa-home-title-height')!==value)group.style.setProperty('--usa-home-title-height',value);});
 }
 function schedule(){if(!frame)frame=requestAnimationFrame(align);}
 function start(){
  const main=document.getElementById('MainContent');if(!main)return;
  new MutationObserver(records=>{
   if(records.some(record=>[...record.addedNodes,...record.removedNodes].some(node=>node.nodeType===1&&(node.matches('.card__heading,.usa-product-name,product-card,.product-grid,.usa-products')||node.querySelector('.card__heading')))))schedule();
  }).observe(main,{childList:true,subtree:true});
  let lastWidth=main.getBoundingClientRect().width;
  new ResizeObserver(entries=>{const width=entries[0].contentRect.width;if(width!==lastWidth){lastWidth=width;schedule();}}).observe(main);
  window.addEventListener('resize',usaWidthLayoutResize(schedule),{passive:true});
  document.fonts?.ready.then(schedule);schedule();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();

/* Keep the numeric product score when the reviews app replaces its stars. */
(()=>{function start(){const root=document.getElementById('usa-product-rating');if(!root)return;function findRating(value){if(!value||typeof value!=='object')return null;if(value.aggregateRating&&Number(value.aggregateRating.ratingValue)>0)return value.aggregateRating;for(const item of Array.isArray(value)?value:Object.values(value)){const rating=findRating(item);if(rating)return rating;}return null;}function getRating(){if(Number(root.dataset.ratingScore)>0)return {ratingValue:root.dataset.ratingScore,bestRating:root.dataset.ratingMax};for(const script of document.querySelectorAll('script[type="application/ld+json"]')){try{const rating=findRating(JSON.parse(script.textContent));if(rating)return rating;}catch(e){}}return null;}function sync(){const data=getRating();if(!data)return;const score=Number(data.ratingValue);const rating=root.querySelector('.areviews_rating');if(!rating||rating.querySelector('.usa-rating-score'))return;const label=document.createElement('span');label.className='usa-rating-score';label.textContent=(Math.round(score*10)/10)+'/'+(data.bestRating||root.dataset.ratingMax||'5');const count=rating.querySelector('span');rating.insertBefore(label,count);};new MutationObserver(sync).observe(root,{childList:true,subtree:true});sync();}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();})();

/* Avoid invalidating styles and notifying app observers when a value is unchanged. */
function usaSetProgressStyle(element,name,value){if(element.style.getPropertyValue(name)!==value)element.style.setProperty(name,value);}
/* Read all rail geometry together, then write progress styles once per frame. */
const usaRailProgressJobs=new Map();
let usaRailProgressFrame=0;
function usaScheduleRailProgress(rail,paint){
 usaRailProgressJobs.set(rail,paint);
 if(usaRailProgressFrame)return;
 usaRailProgressFrame=requestAnimationFrame(()=>{
  usaRailProgressFrame=0;
  const jobs=[...usaRailProgressJobs].filter(([rail])=>rail.isConnected).map(([rail,paint])=>({paint,geometry:{width:rail.clientWidth,total:Math.max(1,rail.scrollWidth),left:Math.max(0,rail.scrollLeft)}}));
  usaRailProgressJobs.clear();
  jobs.forEach(({paint,geometry})=>paint(geometry));
 });
}
/* Dark sections use a fixed marker, rather than a growing fill. */
function usaUpdateDarkRailMarker(rail,track,geometry){
 const homepageRecent=!!rail.closest('body.index-template .section-recently-viewed');
 const dark=!homepageRecent&&!!rail.closest('.usa-home-dark,.usa-last,body.product-template #usa-recommendations,body.product-template .section-recently-viewed');
 track.classList.toggle('usa-seeking-progress',dark);
 if(!dark)return;
 const progress=Math.max(0,Math.min(1,geometry.left/Math.max(1,geometry.total-geometry.width)));
 usaSetProgressStyle(track,'--usa-seek-position',`${progress*88}%`);
}
(()=>{function init(){document.querySelectorAll('.usa-brands').forEach(rail=>{if(rail.dataset.progressReady)return;rail.dataset.progressReady='true';const track=document.createElement('div');track.className='usa-brand-progress';track.setAttribute('aria-hidden','true');track.append(document.createElement('span'));rail.after(track);function update(){usaScheduleRailProgress(rail,geometry=>{usaUpdateDarkRailMarker(rail,track,geometry);const ratio=Math.min(1,geometry.width/geometry.total);if(track.hidden!==(ratio>=1))track.hidden=ratio>=1;usaSetProgressStyle(track,'--brand-thumb',`${Math.min(1,(geometry.width+geometry.left)/geometry.total)*100}%`);usaSetProgressStyle(track,'--brand-progress','0%');});}rail.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(rail);update();});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',init);})();

/* Passive progress indicators for manually swiped editorial rails. */
(()=>{
 function setup(){
  document.querySelectorAll('.usa-campaign-rail,.usa-products,.usa-depts,.usa-discovery-grid,.product-grid:not(#product-grid),.cart__recommendations .complementary-slider,#MainContent .yq-app div:has(>.yq-track-product-recommend-item)').forEach(rail=>{
   if(rail.dataset.usaRailProgress)return;
   rail.dataset.usaRailProgress='true';rail.classList.add('usa-fill-scroll-rail');
   const track=document.createElement('div');track.className='usa-rail-progress';track.setAttribute('aria-hidden','true');track.append(document.createElement('span'));rail.after(track);
   const cartRecommendations=!!rail.closest('.cart__recommendations');
   const lastChance=!!rail.closest('.usa-last')||cartRecommendations,desktop=matchMedia('(min-width:1200px)');
   let dragging=false,grabOffset=0;
   if(lastChance)track.classList.add('usa-last-scrollbar');
   function update(){usaScheduleRailProgress(rail,geometry=>{
    usaUpdateDarkRailMarker(rail,track,geometry);
    const ratio=Math.min(1,geometry.width/Math.max(1,geometry.total));if(track.hidden!==(ratio>=.999))track.hidden=ratio>=.999;
    const fill=Math.min(1,(geometry.width+Math.max(0,geometry.left))/Math.max(1,geometry.total));usaSetProgressStyle(track,'--usa-rail-thumb',`${fill*100}%`);usaSetProgressStyle(track,'--usa-rail-offset','0%');
    if(lastChance){
     const enabled=desktop.matches&&!track.hidden;
     track.setAttribute('aria-hidden',String(!enabled));track.tabIndex=enabled?0:-1;
     if(enabled){track.setAttribute('role','scrollbar');track.setAttribute('aria-label',cartRecommendations?'Recommended products':'Last Chance products');track.setAttribute('aria-orientation','horizontal');track.setAttribute('aria-valuemin','0');track.setAttribute('aria-valuemax','100');track.setAttribute('aria-valuenow',String(Math.round(geometry.left/Math.max(1,geometry.total-geometry.width)*100)));}
     else track.removeAttribute('role');
    }
   });}
   if(lastChance){
    if(!rail.id)rail.id=cartRecommendations?'usa-cart-recommended-products':'usa-last-chance-products';track.setAttribute('aria-controls',rail.id);
    function movePointer(event){const box=track.getBoundingClientRect();const seeking=track.classList.contains('usa-seeking-progress');const thumbWidth=seeking?track.firstElementChild.getBoundingClientRect().width:0;const progress=Math.max(0,Math.min(1,(event.clientX-box.left-(seeking?grabOffset:0))/Math.max(1,box.width-thumbWidth)));rail.scrollTo({left:progress*(rail.scrollWidth-rail.clientWidth),behavior:'instant'});}
    track.addEventListener('pointerdown',event=>{if(!desktop.matches||event.button!==0)return;event.preventDefault();const thumb=track.firstElementChild.getBoundingClientRect();grabOffset=event.clientX>=thumb.left&&event.clientX<=thumb.right?event.clientX-thumb.left:thumb.width/2;dragging=true;track.classList.add('is-dragging');track.setPointerCapture(event.pointerId);track.focus({preventScroll:true});movePointer(event);});
    track.addEventListener('pointermove',event=>{if(dragging)movePointer(event);});
    function end(){dragging=false;track.classList.remove('is-dragging');}
    track.addEventListener('pointerup',end);track.addEventListener('pointercancel',end);track.addEventListener('lostpointercapture',end);
    track.addEventListener('keydown',event=>{if(!desktop.matches)return;const card=rail.firstElementChild,step=card?card.getBoundingClientRect().width+parseFloat(getComputedStyle(rail).columnGap||0):rail.clientWidth;let left=rail.scrollLeft;if(event.key==='ArrowRight')left=left>=rail.scrollWidth-rail.clientWidth-2?0:left+step;else if(event.key==='ArrowLeft')left=left<=2?rail.scrollWidth-rail.clientWidth:left-step;else if(event.key==='Home')left=0;else if(event.key==='End')left=rail.scrollWidth;else if(event.key==='PageDown')left+=rail.clientWidth;else if(event.key==='PageUp')left-=rail.clientWidth;else return;event.preventDefault();rail.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});});
    desktop.addEventListener('change',update);
   }
   rail.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(rail);new MutationObserver(update).observe(rail,{childList:true});update();
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();
 document.addEventListener('shopify:section:load',setup);
 let setupFrame=0;const watch=()=>{if(!setupFrame)setupFrame=requestAnimationFrame(()=>{setupFrame=0;setup()})};new MutationObserver(watch).observe(document.body,{childList:true,subtree:true});
})();

/* Match the mobile header to the active campaign only while over the hero. */
(()=>{
 function init(){
  const hero=document.querySelector('.usa-campaign-hero'),rail=hero?.querySelector('.usa-campaign-rail');
  if(!rail||hero.dataset.colourReady)return;hero.dataset.colourReady='true';
  const mobile=matchMedia('(max-width:1199px)');let frame=0;
  function update(){
   frame=0;const cards=[...rail.querySelectorAll('.usa-campaign-card')];
   const position=Math.max(0,Math.min(cards.length-1,rail.scrollLeft/Math.max(1,rail.clientWidth)));
   const first=Math.floor(position),fraction=position-first;
   const rgb=card=>getComputedStyle(card).getPropertyValue('--usa-card-rgb').split(',').map(Number);
   let colourValue='';
   if(cards.length){
    const from=rgb(cards[first]),to=rgb(cards[Math.min(first+1,cards.length-1)]);
    const colour=from.map((value,i)=>Number((value+(to[i]-value)*fraction).toFixed(2)));
    colourValue=`rgb(${colour.join(',')})`;
   }
   const scrollX=window.scrollX,scrollY=window.scrollY;
   const surfaces=mobile.matches?[hero,...document.querySelectorAll('.section-header,.utility-bar')].map(surface=>({surface,rect:surface.getBoundingClientRect()})):[];
   const heroBottom=(surfaces[0]?.rect||hero.getBoundingClientRect()).bottom;
   // Complete geometry reads before changing inherited styles. Keep stationary values untouched.
   if(colourValue&&document.body.style.getPropertyValue('--usa-campaign-colour')!==colourValue)document.body.style.setProperty('--usa-campaign-colour',colourValue);
   surfaces.forEach(({surface,rect})=>{
    const x=`${-(rect.left+scrollX)%128}px`,y=`${-(rect.top+scrollY)%128}px`;
    if(surface.style.getPropertyValue('--usa-grain-x')!==x)surface.style.setProperty('--usa-grain-x',x);
    if(surface.style.getPropertyValue('--usa-grain-y')!==y)surface.style.setProperty('--usa-grain-y',y);
   });
   document.body.classList.toggle('usa-within-campaign',scrollY<=1);
   document.body.classList.toggle('usa-campaign-visible',heroBottom>0);
  }
  function schedule(){if(!frame)frame=requestAnimationFrame(update);}
  rail.addEventListener('scroll',schedule,{passive:true});window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',usaWidthLayoutResize(schedule),{passive:true});window.addEventListener('pageshow',schedule);mobile.addEventListener('change',schedule);update();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();

/* Ten-second hero rotation on every screen size, with user and visibility controls. */
(()=>{
 function init(){
  const hero=document.querySelector('.usa-campaign-hero'),rail=hero?.querySelector('.usa-campaign-rail');
  if(!rail||hero.dataset.autoplayReady)return;hero.dataset.autoplayReady='true';
  const reduce=matchMedia('(prefers-reduced-motion:reduce)');
  let visible=false,paused=false,interacting=false,nextAt=Date.now()+10000;
  const control=document.createElement('button');control.type='button';control.className='usa-hero-autoplay';control.textContent='Pause';control.setAttribute('aria-label','Pause hero slideshow');control.setAttribute('aria-pressed','false');hero.append(control);
  control.addEventListener('click',()=>{paused=!paused;control.textContent=paused?'Play':'Pause';control.setAttribute('aria-label',paused?'Play hero slideshow':'Pause hero slideshow');control.setAttribute('aria-pressed',String(paused));nextAt=Date.now()+10000;});
  const postpone=()=>{nextAt=Date.now()+10000;};
  rail.addEventListener('pointerdown',()=>{interacting=true;postpone();},{passive:true});
  window.addEventListener('pointerup',()=>{if(interacting){interacting=false;postpone();}},{passive:true});
  window.addEventListener('pointercancel',()=>{interacting=false;postpone();},{passive:true});
  rail.addEventListener('wheel',postpone,{passive:true});rail.addEventListener('keydown',postpone);
  hero.addEventListener('click',event=>{if(event.target.closest('button'))postpone();});
  new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;postpone();},{threshold:.5}).observe(rail);
  document.addEventListener('visibilitychange',postpone);
  function controls(){control.hidden=reduce.matches;postpone();}
  reduce.addEventListener('change',controls);controls();
  const timer=setInterval(()=>{
   if(!hero.isConnected){clearInterval(timer);return;}
   if(Date.now()<nextAt)return;
   if(reduce.matches||!visible||document.hidden||paused||interacting||(rail.matches(':focus-visible')||!!rail.querySelector(':focus-visible'))||(document.body.classList.contains('overflow-hidden')||document.body.style.overflow==='hidden')){postpone();return;}
   const count=rail.querySelectorAll('.usa-campaign-card').length;if(count<2)return;
   const next=(Math.round(rail.scrollLeft/rail.clientWidth)+1)%count;
   rail.scrollTo({left:next*rail.clientWidth,behavior:'smooth'});postpone();
  },250);
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();

/* Product gallery progress. */
(()=>{
 function init(){
  if(!document.body.classList.contains('product-template'))return;
  document.querySelectorAll('media-gallery').forEach(gallery=>{
   const rail=gallery.querySelector('[id^="Slider-Gallery"]');if(!rail||rail.dataset.progressReady)return;rail.dataset.progressReady='true';
   const track=document.createElement('div');track.className='usa-gallery-progress';track.setAttribute('aria-hidden','true');track.append(document.createElement('span'));rail.closest('slider-component').after(track);
   function update(){const count=[...rail.querySelectorAll(':scope > [data-media-id]')].filter(e=>e.getClientRects().length).length;track.hidden=count<2;const progress=Math.max(0,Math.min(1,rail.scrollLeft/Math.max(1,rail.scrollWidth-rail.clientWidth)));const fill=count>1?1/count+progress*(1-1/count):1;track.style.setProperty('--usa-gallery-fill',`${fill*100}%`);}
   rail.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(rail);update();
  });

 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();

/* One outward swipe wraps the hero and Last Chance rails to the other end. */
(()=>{
 function init(){
  document.querySelectorAll('.usa-campaign-rail,.usa-last .usa-products').forEach(rail=>{if(rail.dataset.edgeLoopReady)return;rail.dataset.edgeLoopReady='true';
  let gesture=null,animating=false,suppressClickUntil=0;
  const start=(x,y)=>{if(animating)return;const max=rail.scrollWidth-rail.clientWidth;if(max<=0)return;const tolerance=rail.matches('.usa-campaign-rail')?rail.clientWidth*.55:4;gesture={x,y,first:rail.scrollLeft<=tolerance,last:rail.scrollLeft>=max-tolerance};};
  const finish=(x,y)=>{
   const from=gesture;gesture=null;if(!from||animating)return;
   const dx=x-from.x,dy=y-from.y;if(Math.abs(dx)<8||Math.abs(dx)<Math.abs(dy)*1.1)return;
   if(!((dx<0&&from.last)||(dx>0&&from.first)))return;
   const left=rail.scrollLeft,target=dx<0?0:rail.scrollWidth-rail.clientWidth;
   const savedBehavior=rail.style.scrollBehavior,savedSnap=rail.style.scrollSnapType;
   rail.style.setProperty('scroll-behavior','auto','important');rail.style.setProperty('scroll-snap-type','none','important');rail.scrollTo({left,behavior:'instant'});
   animating=true;suppressClickUntil=Date.now()+1200;
   const began=performance.now(),duration=matchMedia('(prefers-reduced-motion:reduce)').matches?0:Math.min(1000,Math.max(600,Math.abs(target-left)/rail.clientWidth*150));
   function frame(now){const progress=duration?Math.min(1,(now-began)/duration):1;const ease=progress<.5?4*progress**3:1-(-2*progress+2)**3/2;rail.scrollLeft=left+(target-left)*ease;if(progress<1&&rail.isConnected)requestAnimationFrame(frame);else{rail.scrollLeft=target;rail.style.scrollBehavior=savedBehavior;rail.style.scrollSnapType=savedSnap;animating=false;}}
   requestAnimationFrame(frame);
  };
  rail.addEventListener('touchstart',event=>{gesture=null;if(event.touches.length===1)start(event.touches[0].clientX,event.touches[0].clientY);},{passive:true});
  rail.addEventListener('touchmove',event=>{if(animating){if(event.cancelable)event.preventDefault();return;}if(!gesture||event.touches.length!==1)return;const t=event.touches[0],dx=t.clientX-gesture.x,dy=t.clientY-gesture.y;if(((dx<0&&gesture.last)||(dx>0&&gesture.first))&&Math.abs(dx)>=4&&Math.abs(dx)>Math.abs(dy)*1.1){if(event.cancelable)event.preventDefault();if(Math.abs(dx)>=12)finish(t.clientX,t.clientY);}},{passive:false});
  rail.addEventListener('touchend',event=>{if(!event.touches.length&&event.changedTouches.length===1)finish(event.changedTouches[0].clientX,event.changedTouches[0].clientY);else gesture=null;},{passive:true});
  rail.addEventListener('touchcancel',()=>gesture=null,{passive:true});
  rail.addEventListener('pointerdown',event=>{if(event.pointerType==='mouse'&&event.button===0){start(event.clientX,event.clientY);}});
  rail.addEventListener('pointerup',event=>{if(event.pointerType==='mouse')finish(event.clientX,event.clientY);});
  rail.addEventListener('dragstart',event=>event.preventDefault());
  rail.addEventListener('click',event=>{if(Date.now()<suppressClickUntil){event.preventDefault();event.stopImmediatePropagation();}},true);
 });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',init);
})();

/* Last Chance directional browsing alongside drag and swipe. */
(()=>{
 function init(){document.querySelectorAll('.usa-last').forEach(section=>{
  const rail=section.querySelector('.usa-products'),heading=section.querySelector('.usa-heading-row');
  if(!rail||!heading||section.querySelector('.usa-last-controls'))return;
  const controls=document.createElement('div');controls.className='usa-last-controls';
  const buttons=[-1,1].map(direction=>{const button=document.createElement('button');button.type='button';button.setAttribute('aria-label',direction<0?'Previous Last Chance products':'Next Last Chance products');button.setAttribute('aria-controls',rail.id||'usa-last-chance-products');if(!rail.id)rail.id=cartRecommendations?'usa-cart-recommended-products':'usa-last-chance-products';button.innerHTML='<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 12h15M13 5l7 7-7 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';button.addEventListener('click',()=>{const card=rail.firstElementChild;const step=card?card.getBoundingClientRect().width+(parseFloat(getComputedStyle(rail).columnGap)||0):rail.clientWidth;const max=rail.scrollWidth-rail.clientWidth;const left=direction>0&&rail.scrollLeft>=max-2?0:direction<0&&rail.scrollLeft<=2?max:rail.scrollLeft+direction*step;rail.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});});controls.append(button);return button;});
  heading.append(controls);
  const update=()=>{const fits=rail.scrollWidth<=rail.clientWidth+2;buttons.forEach(button=>button.disabled=fits);};rail.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(rail);update();
 });}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',init);
})();

/* Centre desktop navigation on each product rail, excluding headings and scrollbars. */
(()=>{
 function init(){
  document.querySelectorAll('.usa-last>.usa-wrap,.section-recently-viewed slider-component,:is(.related-products,.section-usa-recommended-cards) slider-component').forEach(box=>{
   if(box.dataset.sideArrowsReady)return;const rail=box.querySelector('.usa-products,.product-grid');if(!rail)return;box.dataset.sideArrowsReady='true';
   const update=()=>{const a=box.getBoundingClientRect(),b=(box.closest(':is(.related-products,.section-usa-recommended-cards)')?rail.querySelector('.card__inner')||rail:rail).getBoundingClientRect();box.style.setProperty('--usa-side-arrow-top',`${b.top-a.top+b.height/2}px`);};
   const observer=new ResizeObserver(update);observer.observe(box);observer.observe(rail);update();
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);new MutationObserver(usaBatchDomScan(init)).observe(document.body,{childList:true,subtree:true});
})();
/* Keep Discounty's injected savings badge aligned without rescanning the page. */
(()=>{
 const selector='.discounty-cart-widget__saving-row';
 function paint(row){row.style.setProperty('color','#111','important');row.style.setProperty('border-color','#ddd','important');}
 function update(root){if(root.nodeType!==1)return;const row=root.closest(selector);if(row)paint(row);root.querySelectorAll(selector).forEach(paint);}
 function start(){update(document.body);new MutationObserver(records=>{records.forEach(record=>{const row=record.target.nodeType===1?record.target.closest(selector):null;if(row)paint(row);record.addedNodes.forEach(update);});}).observe(document.body,{childList:true,subtree:true});}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();

/* Tracking recommendations use native desktop scrolling, like the other product rails. */
(()=>{
 if(!/^\/apps\/(?:17track|track-order)\/?$/i.test(location.pathname))return;
 const desktop=matchMedia('(min-width:1200px)');
 function init(){document.querySelectorAll('[class*="ProductRecommend_productRecommend"]').forEach(carousel=>{
  const rail=carousel.querySelector('.swiper-wrapper');if(!rail||rail.dataset.usaNativeTracking)return;
  rail.dataset.usaNativeTracking='true';
  function sync(){
   if(!desktop.matches)return;
   const max=rail.scrollWidth-rail.clientWidth;
   [['.swiper-button-prev',rail.scrollLeft<=1],['.swiper-button-next',rail.scrollLeft>=max-1]].forEach(([selector,disabled])=>{
    const button=carousel.querySelector(selector);if(!button)return;
    button.setAttribute('aria-disabled',String(disabled));button.classList.toggle('usa-tracking-disabled',disabled);
   });
  }
  carousel.addEventListener('click',event=>{
   if(!desktop.matches)return;
   const button=event.target.closest('.swiper-button-prev,.swiper-button-next');if(!button)return;
   event.preventDefault();event.stopImmediatePropagation();
   const card=rail.querySelector('.swiper-slide');const step=card?card.getBoundingClientRect().width+16:rail.clientWidth;
   rail.scrollBy({left:button.matches('.swiper-button-next')?step:-step,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
  },true);
  // Let the browser own horizontal touchpad movement; no wheel-to-click conversion.
  rail.addEventListener('pointerdown',event=>{if(desktop.matches)event.stopPropagation();},true);
  rail.addEventListener('scroll',sync,{passive:true});new ResizeObserver(sync).observe(rail);desktop.addEventListener('change',sync);sync();
 });}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 new MutationObserver(usaBatchDomScan(init)).observe(document.body,{childList:true,subtree:true});
})();

/* One owner for horizontal image gestures: native vertical scrolling stays available. */
(()=>{
 function init(){document.querySelectorAll('media-gallery [id^="Slider-Gallery"]').forEach(rail=>{
  if(rail.dataset.usaSwipeOwner)return;rail.dataset.usaSwipeOwner='true';
  const hero=rail.matches('.usa-campaign-rail');let gesture=null,frame=0,suppress=0;
  const enabled=()=>hero||innerWidth<1200;
  function slides(){return [...rail.children].filter(e=>e.matches(hero?'.usa-campaign-card':'[data-media-id]')&&e.getClientRects().length);}
  function positions(){const box=rail.getBoundingClientRect(),max=rail.scrollWidth-rail.clientWidth;return slides().map(e=>Math.max(0,Math.min(max,e.getBoundingClientRect().left-box.left+rail.scrollLeft)));}
  function restore(){rail.style.removeProperty('scroll-snap-type');rail.style.removeProperty('scroll-behavior');}
  function settle(target,loop){
   cancelAnimationFrame(frame);const from=rail.scrollLeft,began=performance.now(),duration=matchMedia('(prefers-reduced-motion:reduce)').matches?0:loop?Math.min(850,Math.max(600,Math.abs(target-from)/rail.clientWidth*160)):(hero?650:320);
   function tick(now){const t=duration?Math.min(1,(now-began)/duration):1,ease=1-(1-t)**3;rail.scrollLeft=from+(target-from)*ease;if(t<1&&rail.isConnected)frame=requestAnimationFrame(tick);else{rail.scrollLeft=target;frame=0;restore();}}
   frame=requestAnimationFrame(tick);
  }
  if(hero)rail.addEventListener('usa-hero-go',event=>{rail.style.setProperty('scroll-snap-type','none','important');rail.style.setProperty('scroll-behavior','auto','important');settle(event.detail.left,Math.abs(event.detail.left-rail.scrollLeft)>rail.clientWidth*1.5);});
  function begin(e){
   if(!enabled()||!e.isPrimary||e.button!==0)return;
   cancelAnimationFrame(frame);frame=0;const points=positions();if(points.length<2)return;
   const index=points.reduce((best,p,i)=>Math.abs(p-rail.scrollLeft)<Math.abs(points[best]-rail.scrollLeft)?i:best,0);
   gesture={id:e.pointerId,x:e.clientX,y:e.clientY,left:rail.scrollLeft,index,points,horizontal:false};
   rail.style.setProperty('scroll-snap-type','none','important');rail.style.setProperty('scroll-behavior','auto','important');
   rail.scrollTo({left:gesture.left,behavior:'instant'});
  }
  function move(e){
   if(!gesture||gesture.id!==e.pointerId)return;
   const dx=e.clientX-gesture.x,dy=e.clientY-gesture.y;
   if(!gesture.horizontal){if(Math.abs(dy)>Math.abs(dx)&&Math.abs(dy)>8){gesture=null;restore();return;}if(Math.abs(dx)<8||Math.abs(dx)<=Math.abs(dy))return;gesture.horizontal=true;if(e.pointerType!=='touch')rail.setPointerCapture(e.pointerId);}
   e.preventDefault();e.stopImmediatePropagation();rail.scrollLeft=gesture.left-dx;
  }
  function end(e){
   if(!gesture||gesture.id!==e.pointerId)return;const g=gesture;gesture=null;
   const dx=e.clientX-g.x,dy=e.clientY-g.y;
   if(!g.horizontal||Math.abs(dx)<20||Math.abs(dx)<=Math.abs(dy)){settle(g.points[g.index],false);return;}
   e.preventDefault();e.stopImmediatePropagation();suppress=Date.now()+500;
   const next=g.index+(dx<0?1:-1),loop=next<0||next>=g.points.length;
   settle(g.points[(next+g.points.length)%g.points.length],loop);
  }
  // Touch Events remain reliable when mobile browsers cancel a Pointer Event stream.
  function touchEvent(event,touch){return {pointerId:touch.identifier,pointerType:'touch',isPrimary:true,button:0,clientX:touch.clientX,clientY:touch.clientY,preventDefault:()=>{if(event.cancelable)event.preventDefault();},stopImmediatePropagation:()=>event.stopImmediatePropagation()};}
  rail.addEventListener('touchstart',event=>{if(event.touches.length===1)begin(touchEvent(event,event.touches[0]));else{gesture=null;restore();}},{capture:true,passive:true});
  rail.addEventListener('touchmove',event=>{if(event.touches.length===1)move(touchEvent(event,event.touches[0]));},{capture:true,passive:false});
  rail.addEventListener('touchend',event=>{if(!event.touches.length&&event.changedTouches.length===1)end(touchEvent(event,event.changedTouches[0]));},{capture:true,passive:false});
  rail.addEventListener('touchcancel',()=>{if(gesture)settle(gesture.points[gesture.index],false);gesture=null;},{capture:true,passive:true});
  rail.addEventListener('pointerdown',event=>{if(event.pointerType!=='touch')begin(event);},true);
  rail.addEventListener('pointermove',event=>{if(event.pointerType!=='touch')move(event);},true);
  rail.addEventListener('pointerup',event=>{if(event.pointerType!=='touch')end(event);},true);
  rail.addEventListener('pointercancel',event=>{if(event.pointerType!=='touch'){gesture=null;restore();}},true);
  rail.addEventListener('dragstart',e=>{if(enabled())e.preventDefault();});
  rail.addEventListener('click',e=>{if(Date.now()<suppress){e.preventDefault();e.stopImmediatePropagation();}},true);
 });}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();

/* Reflect the product's advertised volume tiers in the selected-quantity price. */
(()=>{
 function start(){
  if(!document.body.classList.contains('product-template'))return;
  let pending=false;
  function update(){pending=false;
   document.querySelectorAll('product-info').forEach(product=>{
    const quantity=product.querySelector('quantity-input input[name="quantity"]');
    const metadata=product.querySelector('[data-usa-unit-price]');
    if(!quantity||!metadata)return;
    const box=metadata.parentElement,qty=Number(quantity.value),unit=Number(metadata.dataset.usaUnitPrice);
    const widget=product.querySelector('.discounty-volume-discount-widget');
    const criteria=widget?[...widget.querySelectorAll('.discounty-volume-discount-widget__criteria')]:[];
    const discounts=widget?[...widget.querySelectorAll('.discounty-volume-discount-widget__discount')]:[];
    let percent=0;
    criteria.forEach((criterion,i)=>{const minimum=Number(criterion.textContent.match(/\d+/)?.[0]);const discount=discounts[i]?.textContent.match(/(\d+(?:\.\d+)?)\s*%/);if(minimum&&discount&&qty>=minimum)percent=Math.max(percent,Number(discount[1]));});
    if(widget&&criteria.length){
     const wrapper=widget.querySelector('.discounty-volume-discount-widget__table-wrapper');
     if(wrapper){wrapper.style.setProperty('border','0','important');wrapper.style.setProperty('border-radius','0','important');wrapper.style.setProperty('background','transparent','important');}
     const form=product.querySelector('product-form');
     let offers=product.querySelector('.usa-volume-offers');
     const intro=product.querySelector('.usa-product-intro');
     if(intro&&!offers){offers=document.createElement('section');offers.className='usa-volume-offers';offers.setAttribute('aria-label','Quantity savings');offers.innerHTML='<h2>Buy more, save more</h2>';}
     if(intro&&offers&&intro.nextElementSibling!==offers)intro.after(offers);
     const slot=widget.closest('#usa-discounty-slot');
     if(offers&&slot&&slot.parentElement!==offers)offers.append(slot);
     criteria.forEach((criterion,i)=>{const row=criterion.closest('tr'),minimum=Number(criterion.textContent.match(/\d+/)?.[0]),discount=Number(discounts[i]?.textContent.match(/(\d+(?:\.\d+)?)\s*%/)?.[1]);if(row)row.classList.toggle('usa-tier-active',percent>0&&discount===percent&&qty>=minimum);});
    }
    let summary=box.querySelector('.usa-quantity-price');
    const show=qty>1&&percent>0&&unit>0;
    box.classList.toggle('usa-has-quantity-price',show);
    if(!show){if(summary)summary.remove();return;}
    const formatter=new Intl.NumberFormat('en-GB',{style:'currency',currency:metadata.dataset.usaPriceCurrency||'GBP'});
    const each=unit*(1-percent/100);
    const html='<div class="usa-quantity-price-total"><s>'+formatter.format(unit/100)+'</s><strong>'+formatter.format(each/100)+'</strong></div><div class="usa-quantity-price-detail">Each · Save '+percent+'%</div>';
    if(!summary){summary=document.createElement('div');summary.className='usa-quantity-price';box.append(summary);}
    if(summary.innerHTML!==html)summary.innerHTML=html;
   });
  }
  function schedule(){if(!pending){pending=true;requestAnimationFrame(update);}}
  document.addEventListener('change',schedule);document.addEventListener('input',schedule);
  new MutationObserver(schedule).observe(document.querySelector('#MainContent'),{childList:true,subtree:true});update();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();

/* Measure the real header offset so desktop heroes end at the viewport bottom. */
(()=>{
 function init(){
  const hero=document.querySelector('.usa-campaign-hero');if(!hero||hero.dataset.viewportReady)return;
  hero.dataset.viewportReady='true';let frame;
  function update(){if(window.matchMedia('(max-width:1199px)').matches&&window.scrollY>1&&hero.style.getPropertyValue('--usa-hero-top'))return;cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{const top=`${Math.max(0,hero.getBoundingClientRect().top+window.scrollY)}px`;if(hero.style.getPropertyValue('--usa-hero-top')!==top)hero.style.setProperty('--usa-hero-top',top);});}
  window.addEventListener('resize',usaWidthLayoutResize(update),{passive:true});window.addEventListener('pageshow',update);
  const observer=new ResizeObserver(update);document.querySelectorAll('.section-header,.shopify-section-group-header-group').forEach(el=>observer.observe(el));
  if(document.fonts)document.fonts.ready.then(update);update();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();

/* Shared Add + pills: preserve existing forms, variant pickers and cart handlers. */
(()=>{
 function sync(buttons){
  buttons.forEach(button=>{
   const label=(button.getAttribute('aria-label')||button.textContent||'').toLowerCase();
   if(button.matches('.usa-bell-action,.usa-compact-notify')||button.querySelector('.usa-notify-icon')||/notify/.test(label)){
    if(!button.classList.contains('usa-notify-pill')){
     button.classList.add('usa-notify-pill');button.dataset.usaNotifyPill='';
     const text=document.createElement('span');text.className='usa-notify-pill-label';text.textContent='Notify';button.append(text);
     button.closest('.quick-add')?.classList.add('usa-notify-pill-slot');
    }
    return;
   }
   if(button.matches('.usa-add-pill')||!/cart/.test(label)||/pre.?order|sold out|choose|options/.test(label))return;
   button.classList.add('usa-add-pill');button.dataset.usaPill='';
   const text=document.createElement('span');text.className='usa-add-pill-label';text.textContent='Add +';button.append(text);
   button.closest('.quick-add')?.classList.add('usa-add-pill-slot');
  });
 }
 const selector='.quick-add__submit,.usa-compact-action';
 const pending=new Set();let frame=0;
 function collect(root){
  if(root.nodeType!==1)return;
  const button=root.closest(selector);if(button)pending.add(button);
  root.querySelectorAll(selector).forEach(button=>pending.add(button));
 }
 function start(){
  sync(document.querySelectorAll(selector));
  new MutationObserver(records=>{
   records.forEach(record=>{
    const button=record.target.nodeType===1?record.target.closest(selector):null;
    if(button)pending.add(button);
    record.addedNodes.forEach(collect);
   });
   if(pending.size&&!frame)frame=requestAnimationFrame(()=>{
    frame=0;const buttons=[...pending].filter(button=>button.isConnected);pending.clear();sync(buttons);
   });
  }).observe(document.body,{childList:true,subtree:true});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();

/* Stable document offset: scrolling must not resize the opening product photo. */
(function () {
  function initViewportGallery() {
    var gallery = document.querySelector('.section-product-page .product__media-list');
    if (!gallery) return;
    var frame = 0;
    function measure() {
      frame = 0;
      if (!window.matchMedia('(min-width:1200px)').matches) return;
      var top = Math.max(0, gallery.getBoundingClientRect().top + window.scrollY);
      var value = top.toFixed(2) + 'px';
      if (gallery.style.getPropertyValue('--usa-gallery-document-top') !== value) {
        gallery.style.setProperty('--usa-gallery-document-top', value);
      }
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(measure); }
    schedule();
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('load', schedule, { once: true });
    if (document.fonts) document.fonts.ready.then(schedule);
    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(schedule);
      document.querySelectorAll('.section-header,.shopify-section-group-header-group').forEach(function (node) { observer.observe(node); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initViewportGallery, { once: true });
  else initViewportGallery();
})();

/* Restock app: use standard DOM events for backdrop dismissal in every browser. */
(()=>{
  const frames=new WeakSet(),documents=new WeakSet();
  function bind(frame){
    function attach(){
      let doc;
      try{doc=frame.contentDocument;}catch(_){return;}
      if(!doc||documents.has(doc))return;
      documents.add(doc);
      let beganOutside=false;
      doc.addEventListener('pointerdown',event=>{
        const panel=doc.querySelector('.modal-container');
        beganOutside=Boolean(panel&&!panel.contains(event.target));
      },true);
      doc.addEventListener('click',event=>{
        const panel=doc.querySelector('.modal-container');
        if(!panel||panel.contains(event.target)||!beganOutside)return;
        beganOutside=false;
        panel.querySelector('button.action-close')?.click();
      },true);
    }
    if(!frames.has(frame)){frames.add(frame);frame.addEventListener('load',attach);}
    attach();
  }
  function scan(){const frame=document.getElementById('gw-stock-fulfilled-iframe');if(frame)bind(frame);}
  new MutationObserver(records=>{if(records.some(record=>record.addedNodes.length))scan();}).observe(document.documentElement,{childList:true,subtree:true});
  scan();
})();

/* Homepage Last Chance: advance one card every five seconds while in view. */
(() => {
  function init() {
    document.querySelectorAll('body.index-template .usa-last').forEach(section => {
      const rail = section.querySelector('.usa-products');
      if (!rail || rail.dataset.autoplayReady) return;
      rail.dataset.autoplayReady = 'true';
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false, hovered = false, touching = false, timer;
      function stop() { clearTimeout(timer); }
      function schedule() {
        stop();
        if (!visible || document.hidden || reduced.matches || hovered || touching || section.contains(document.activeElement)) return;
        timer = setTimeout(() => {
          if (!rail.isConnected) return;
          const max = rail.scrollWidth - rail.clientWidth;
          const card = rail.querySelector('.usa-product');
          if (max > 2 && card) {
            const step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).columnGap) || 0);
            rail.scrollTo({left: rail.scrollLeft >= max - 2 ? 0 : Math.min(max, rail.scrollLeft + step), behavior: 'smooth'});
          }
          schedule();
        }, 5000);
      }
      section.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovered = true; stop(); } });
      section.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { hovered = false; schedule(); } });
      section.addEventListener('pointerdown', () => { touching = true; stop(); }, {passive:true});
      window.addEventListener('pointerup', () => { if (touching) { touching = false; schedule(); } }, {passive:true});
      window.addEventListener('pointercancel', () => { touching = false; schedule(); }, {passive:true});
      section.addEventListener('focusin', stop);
      section.addEventListener('focusout', () => setTimeout(schedule, 0));
      section.addEventListener('wheel', schedule, {passive:true});
      document.addEventListener('visibilitychange', schedule);
      reduced.addEventListener('change', schedule);
      window.addEventListener('pagehide', stop);
      window.addEventListener('pageshow', schedule);
      new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }, {threshold:0}).observe(rail);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Desktop homepage Recently Viewed: advance every five seconds while in view. */
(() => {
  function init() {
    document.querySelectorAll('body.index-template .section-recently-viewed').forEach(section => {
      const rail = section.querySelector('.product-grid');
      if (!rail || rail.dataset.recentAutoplayReady) return;
      rail.dataset.recentAutoplayReady = 'true';
      const desktop = matchMedia('(min-width:1200px)');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false, hovered = false, touching = false, timer;
      function stop() { clearTimeout(timer); }
      function schedule() {
        stop();
        if (!desktop.matches || !visible || document.hidden || reduced.matches || hovered || touching || section.contains(document.activeElement)) return;
        timer = setTimeout(() => {
          if (!rail.isConnected) return;
          const max = rail.scrollWidth - rail.clientWidth;
          const card = rail.querySelector('.grid__item');
          if (max > 2 && card) {
            const step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).columnGap) || 0);
            rail.scrollTo({left: rail.scrollLeft >= max - 2 ? 0 : Math.min(max, rail.scrollLeft + step), behavior: 'smooth'});
          }
          schedule();
        }, 5000);
      }
      section.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovered = true; stop(); } });
      section.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { hovered = false; schedule(); } });
      section.addEventListener('pointerdown', () => { touching = true; stop(); }, {passive:true});
      window.addEventListener('pointerup', () => { if (touching) { touching = false; schedule(); } }, {passive:true});
      window.addEventListener('pointercancel', () => { touching = false; schedule(); }, {passive:true});
      section.addEventListener('focusin', stop);
      section.addEventListener('focusout', () => setTimeout(schedule, 0));
      section.addEventListener('wheel', schedule, {passive:true});
      document.addEventListener('visibilitychange', schedule);
      reduced.addEventListener('change', schedule);
      desktop.addEventListener('change', schedule);
      window.addEventListener('pagehide', stop);
      window.addEventListener('pageshow', schedule);
      new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }, {threshold:0}).observe(rail);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
  const host = document.querySelector('.section-recently-viewed');
  if (host) new MutationObserver(init).observe(host, {childList:true, subtree:true});
})();

/* A native full-card product link, with Add + above it. */
(() => {
 function init() {
  document.querySelectorAll('.usa-best-sellers .card').forEach(card => {
   if (card.querySelector('.usa-best-card-link')) return;
   const title = card.querySelector('.card__information .card__heading a[href]');
   if (!title) return;
   const link = document.createElement('a');
   link.className = 'usa-best-card-link'; link.href = title.href;
   link.tabIndex = -1; link.setAttribute('aria-hidden', 'true');
   card.appendChild(link);
  });
 }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
 document.addEventListener('shopify:section:load', init);
})();

/* Clip category photo zoom inside its own frame, above the label. */
(() => {
 function init() {
  document.querySelectorAll('.usa-dept > img.usa-dept-photo').forEach(image => {
   const frame = document.createElement('span');
   frame.className = 'usa-dept-photo-frame';
   image.before(frame); frame.appendChild(image);
  });
 }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
 document.addEventListener('shopify:section:load', init);
})();

/* Native whole-card links for asynchronously loaded Picked for You cards. */
(() => {
 function init() {
  document.querySelectorAll('#usa-picked-for-you .card').forEach(card => {
   if (card.querySelector('.usa-picked-card-link')) return;
   const title = card.querySelector('.card__information .card__heading a[href]');
   if (!title) return;
   const link = document.createElement('a');
   link.className = 'usa-picked-card-link'; link.href = title.href;
   link.tabIndex = -1; link.setAttribute('aria-hidden', 'true');
   card.appendChild(link);
  });
 }
 function start() {
  init();
  const host = document.querySelector('#usa-picked-for-you');
  if (host && !host.dataset.usaCardLinksObserved) {
   host.dataset.usaCardLinksObserved = 'true';
   new MutationObserver(init).observe(host, {childList:true, subtree:true});
  }
 }
 if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
 document.addEventListener('shopify:section:load',start);
})();

/* Draft-only AcneFree manufacturer image comparison, original catalogue retained. */
(()=>{
 const replacements={"Screenshot2022-11-11105359.png": "https://cdn.shopify.com/s/files/1/0439/3733/3408/products/benzoylperoxideWash-Front.jpg?v=1633725579", "Screenshot2022-11-11105415.png": "https://cdn.shopify.com/s/files/1/0439/3733/3408/products/benzoylperoxideWash-Back.jpg?v=1633725710", "OilFreeCleanser_1.png": "https://cdn.shopify.com/s/files/1/0439/3733/3408/products/OilFreeCleanser_1.png?v=1629311230", "Screenshot2023-01-31143726.png": "https://cdn.shopify.com/s/files/1/0439/3733/3408/products/OilFreeCleanser.png?v=1629311230"};
 function update(root=document){
  const images=root.matches?.('img')?[root]:root.querySelectorAll?.('img:not([data-usa-acnefree-trial])')||[];
  images.forEach(img=>{
   const source=img.getAttribute('src')||'';
   const key=Object.keys(replacements).find(name=>source.split('?')[0].endsWith('/'+name));
   if(!key)return;
   img.dataset.usaAcnefreeTrial='true';
   img.removeAttribute('srcset');
   img.src=replacements[key];
   const picture=img.closest('picture');if(picture)picture.querySelectorAll('source').forEach(s=>s.removeAttribute('srcset'));
  });
 }
 function start(){update();new MutationObserver(records=>{for(const record of records)for(const node of record.addedNodes)if(node.nodeType===1)update(node);}).observe(document.body,{childList:true,subtree:true});}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();

/* Native Recently Viewed card links, including asynchronously rendered cards. */
(()=>{
 function update(){document.querySelectorAll('.section-recently-viewed .card').forEach(card=>{
  if(card.querySelector('.usa-recent-card-link'))return;
  const title=card.querySelector('.card__information .card__heading a[href]');if(!title)return;
  const link=document.createElement('a');link.className='usa-recent-card-link';link.href=title.href;link.tabIndex=-1;link.setAttribute('aria-hidden','true');card.appendChild(link);
 });}
 function start(){update();document.querySelectorAll('.section-recently-viewed').forEach(host=>{if(host.dataset.usaLinksObserved)return;host.dataset.usaLinksObserved='true';new MutationObserver(update).observe(host,{childList:true,subtree:true});});}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();document.addEventListener('shopify:section:load',start);
})();

/* Compact welcome offer can be dismissed for this browser session. */
(()=>{
 const key='usa-offer-tab-dismissed';
 function init(){
  try{if(sessionStorage.getItem(key)==='1')document.body.classList.add('usa-offer-tab-dismissed');}catch(e){}
  const tab=document.getElementById('usa-signup-edge-tab');if(!tab||document.getElementById('usa-signup-edge-dismiss'))return;
  tab.textContent='10% OFF £20+';
  const close=document.createElement('button');close.type='button';close.id='usa-signup-edge-dismiss';close.setAttribute('aria-label','Dismiss welcome offer tab');close.textContent='×';
  close.addEventListener('click',()=>{document.body.classList.add('usa-offer-tab-dismissed');try{sessionStorage.setItem(key,'1');}catch(e){}});
  tab.after(close);
  function position(){const r=tab.getBoundingClientRect();close.style.top=Math.max(0,r.top-30)+'px';}
  position();window.addEventListener('resize',position,{passive:true});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 new MutationObserver(usaBatchDomScan(init)).observe(document.documentElement,{childList:true,subtree:true});
})();

/* Brisk mobile recommendation arrows; native swipes keep their momentum. */
(()=>{
 const running=new WeakMap();
 document.addEventListener('click',event=>{
  if(innerWidth>=1200||!document.body.classList.contains('product-template'))return;
  const button=event.target.closest('.slider-button');
  const section=button?.closest('.section-usa-recommended-cards,.section-related-products,.section-recently-viewed');
  const rail=section?.querySelector('.product-grid');
  if(!rail||button.disabled)return;
  const direction=button.name==='next'||button.classList.contains('slider-button--next')?1:button.name==='previous'||button.classList.contains('slider-button--prev')?-1:0;
  if(!direction)return;
  event.preventDefault();event.stopImmediatePropagation();
  cancelAnimationFrame(running.get(rail));
  const from=rail.scrollLeft,step=(rail.firstElementChild?.getBoundingClientRect().width||rail.clientWidth)+(parseFloat(getComputedStyle(rail).columnGap)||0);
  const target=Math.max(0,Math.min(rail.scrollWidth-rail.clientWidth,from+direction*step));
  const start=performance.now(),duration=matchMedia('(prefers-reduced-motion:reduce)').matches?0:100;
  rail.style.setProperty('scroll-snap-type','none','important');
  function tick(now){const t=duration?Math.min(1,(now-start)/duration):1;rail.scrollLeft=from+(target-from)*(1-(1-t)**3);if(t<1)running.set(rail,requestAnimationFrame(tick));else{rail.style.removeProperty('scroll-snap-type');running.delete(rail);}}
  running.set(rail,requestAnimationFrame(tick));
 },true);
})();

/* Match desktop discovery ordering: New In, finder, Best Sellers, Last Chance. */
(()=>{
 function alignFinder(){
  const finder=document.querySelector('#menu-drawer a[href="/#acne-finder"]')?.closest('li');
  const newest=document.querySelector('#menu-drawer a[href="/collections/new-in-1"]')?.closest('li');
  const best=document.querySelector('#menu-drawer a[href="/collections/best-sellers"]')?.closest('li');
  if(!finder||!newest||!best||finder.parentElement!==best.parentElement||newest.parentElement!==best.parentElement)return;
  if(newest.nextElementSibling!==finder||finder.nextElementSibling!==best){best.before(newest);best.before(finder);}
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',alignFinder,{once:true});else alignFinder();
 document.addEventListener('shopify:section:load',alignFinder);
 const drawer=document.querySelector('#menu-drawer');if(drawer)new MutationObserver(alignFinder).observe(drawer,{childList:true,subtree:true});
})();

/* Match the fixed purchase bar to the page surface immediately behind it. */
(()=>{
 function init(){
  const bar=document.querySelector('body.product-template .sticky-cta');
  if(!bar||bar.dataset.surfaceReady)return;
  bar.dataset.surfaceReady='true';let frame=0;
  function update(){
   frame=0;
   const y=Math.max(0,Math.min(innerHeight-1,bar.getBoundingClientRect().top-2));
   const surface=document.elementsFromPoint(2,y).find(el=>el.tagName!=='IFRAME'&&!bar.contains(el)&&!el.closest('#usa-page-loader')&&(el.closest('#MainContent')||el.closest('footer')));
   let dark=false;
   for(let el=surface;el;el=el.parentElement){
    const colour=getComputedStyle(el).backgroundColor;
    const values=colour.match(/[\d.]+/g)?.map(Number);
    if(!values||values.length<3||(values.length>3&&values[3]<0.5))continue;
    if(Math.max(...values.slice(0,3))<65){dark=true;break;}
   }
   bar.classList.toggle('usa-sticky-dark',!dark);
  }
  function schedule(){if(!frame)frame=requestAnimationFrame(update);}
  addEventListener('scroll',schedule,{passive:true});
  addEventListener('resize',schedule,{passive:true});
  addEventListener('pageshow',schedule);
  new ResizeObserver(schedule).observe(document.getElementById('MainContent'));
  schedule();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
